import actionsDocuments from "./actions";

export default {
  namespaced: true,
  actions: actionsDocuments,
};
